import React, { FC } from 'react'

import { IconStateInfoInverseProps } from './IconStateInfoInverse.types'
import * as Styled from './styles/IconStateInfoInverse.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStateInfoInverse: FC<IconStateInfoInverseProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStateInfoInverseProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconStateInfoInverseProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <defs>
          <path id='5ca525c5-f435-41a0-baae-01cb18a8dadf__a' d='M0 0h159.696v159.696H0z' />
        </defs>
        <g fill='none' fillRule='evenodd'>
          <mask id='5ca525c5-f435-41a0-baae-01cb18a8dadf__b' fill='#fff'>
            <path d='M0 0h159.696v159.696H0z' />
          </mask>
          <path
            d='M79.848 0c44.099 0 79.848 35.75 79.848 79.848 0 44.099-35.749 79.848-79.848 79.848S0 123.946 0 79.848C0 35.749 35.75 0 79.848 0Zm.208 62.618h-9.863a4.69 4.69 0 0 0 0 9.377h5.174v42.235h-4.762a4.69 4.69 0 0 0 0 9.377h18.898a4.69 4.69 0 0 0 0-9.377h-4.759V67.307a4.69 4.69 0 0 0-4.688-4.689Zm-.208-26.529a6.483 6.483 0 1 0 0 12.967 6.483 6.483 0 0 0 0-12.967Z'
            fill='#FFF'
            mask='url(#5ca525c5-f435-41a0-baae-01cb18a8dadf__b)'
          />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStateInfoInverse
